import React from 'react'
import { Button, Layout, Card, Form as AntForm } from 'antd'
import { get, has } from 'lodash'
import * as Yup from 'yup'
import { Text, Logo } from '../src/components/common'
import { withAWSAuth } from '../src/hoc'
import { Field, Formik, Form } from 'formik'
import { AntInput } from '../src/components/form-handlers/AntFieldFactory'

const ValidationSchema = Yup.object().shape({
    code: Yup.string()
        .required(<Text text='form.validations.required' />),
    username: Yup.string()
        .email(<Text text='form.validations.email' />)
        .required(<Text text='form.validations.required' />),
    password: Yup.string()
        .required(<Text text='form.validations.required' />)
})

const LoginDisplayForm = ({ errors, dirty, isSubmitting, handleSubmit, handleReset, submitCount, ...props }) => (
    (
        <Form className='ant-form' onSubmit={handleSubmit} onReset={handleReset}>

            <Field
                containerClassName='flex-1'
                containerProps={{ labelCol: { span: 24 }, wrapperCol: { span: 24 } }}
                component={AntInput}
                name='code'
                type='input'
                label='Codigo de verificación'
                hasFeedback
                placeholder='código'
                disabled={isSubmitting}
                allowClear
                submitCount={submitCount}
            />

            <Field
                containerClassName='flex-1'
                containerProps={{ labelCol: { span: 24 }, wrapperCol: { span: 24 } }}
                component={AntInput}
                name='username'
                type='input'
                label='Email'
                hasFeedback
                placeholder='email'
                disabled={isSubmitting}
                allowClear
                submitCount={submitCount}
            />
            <Field
                containerClassName='flex-1'
                containerProps={{ labelCol: { span: 24 }, wrapperCol: { span: 24 } }}
                component={AntInput}
                name='password'
                type='password'
                label='Nueva Clave'
                hasFeedback
                placeholder='xxxxx'
                disabled={isSubmitting}
                allowClear
                submitCount={submitCount}
            />
            {has(errors, 'response') && (
                <div className='has-error text-align-center'>
                    <span className='ant-form-explain'>{get(errors, 'response')}</span>
                </div>
            )}
            <AntForm.Item className='text-align-center'>
                {/* <a className='login-form-forgot' href=''>Olvide clave</a> */}
                <Button type='primary' htmlType='submit' className='login-form-button' disabled={isSubmitting} loading={isSubmitting}>
                    Cambiar Clave
                </Button>
                {/* <a href=''>Solicitar Acceso</a> */}
            </AntForm.Item>
        </Form>
    )
)
const LoginForm = ({ handleSubmit, handleReset, initialValues, isSubmitting }) => (
    <Formik
        onSubmit={handleSubmit}
        onReset={handleReset}
        initialValues={initialValues}
        validationSchema={ValidationSchema}
        render={LoginDisplayForm}
    />
)

class ForgotPassword extends React.Component {
    handleSubmit = (values, { setSubmitting, setFieldError }) => {
        const { awsAuth } = this.props
        setSubmitting(true)
        awsAuth.forgotPasswordSubmit(values)
            .then((resp) => this.props.history.push('/'))
            .catch((err) => {
                console.log(err)
                setSubmitting(false)
            })
    };

    render () {
        return (
            <Layout>
                <div className='login-form-container'>
                    <div className='login-form-wrapper'>
                        <Card>
                            <Logo />
                            <LoginForm handleSubmit={this.handleSubmit.bind(this)} />
                        </Card>
                    </div>
                </div>

            </Layout>
        )
    }
}
export default withAWSAuth(ForgotPassword);
